// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsClsEnrollmentEnrollSuccessResponse } from './clsClsEnrollmentEnrollSuccessResponse.js';
import type { EntlibFailureany } from './entlibFailureany.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClsClsEnrollmentEnrollResponse {
    'data': any | null;
    'success': boolean;
    'messages': Array<string> | null;

    static discriminator = "success" as const;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClsClsEnrollmentEnrollResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "any"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return ClsClsEnrollmentEnrollResponse.attributeTypeMap;
    }
}
